import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import { commonService } from "../../../utils/commonService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiCall } from "../../../utils/axiosService";
import { apiResponse } from "../../../utils/apiResponse";
import "../../../Assets/Styles/component.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Loader from "../../Loader/Loader";
import moment from "moment";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const ChannelMix = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    ChannelMixTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const getChannelMixData = async () => {
    setLoading(true);

    let ChannelMixResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MORNING_BRIEFING.GET_CHANNEL_MIX,
        body: {
          staydate: para?.asOfDate,
          propertycode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
        },
      },
      false,
    );

    let response = apiResponse(false, ChannelMixResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data || [];
      setData(dataFromApi);
    } else {
      setData([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      const startDate = moment(para?.asOfDate || new Date());
      const channels = ["EXPEDIA", "BOOKING.COM", "BRAND", "UNMAPPED"];
      const staticData = [];

      for (let i = 0; i < 7; i++) {
        const dateStr = moment(startDate).add(i, "days").format("YYYY-MM-DD");
        const expediaVal = Math.floor(15 + Math.sin(i) * 5 + (i % 3) * 2);
        const bookingVal = Math.floor(25 + Math.cos(i) * 6 + (i % 4) * 3);
        const brandVal = Math.floor(35 + Math.sin(i * 0.5) * 8);
        const unmappedVal = Math.floor(8 + (i % 3) * 2);

        const channelVals = {
          EXPEDIA: expediaVal,
          "BOOKING.COM": bookingVal,
          BRAND: brandVal,
          UNMAPPED: unmappedVal,
        };

        channels.forEach((ch) => {
          staticData.push({
            AsOfDate: dateStr,
            channelpartner: ch,
            RoomSold: channelVals[ch],
          });
        });
      }

      setData(staticData);
      setLoading(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getChannelMixData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  // Extract unique dates and sort them
  const rawData = Array.isArray(data) ? data : [];
  const uniqueDates = Array.from(
    new Set(rawData.map((item) => item.AsOfDate)),
  ).sort();
  const labels = uniqueDates.map((date) => moment(date).format("MMM D"));

  // Extract unique channels
  const uniqueChannels = Array.from(
    new Set(rawData.map((item) => item.channelpartner)),
  );

  const getChannelColor = (channel, index) => {
    const map = {
      EXPEDIA: "#f59e0b",
      "BOOKING.COM": "#3b82f6",
      BRAND: "#10b981",
      UNMAPPED: "#06b6d4",
    };
    const fallbacks = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ec4899"];
    return map[channel?.toUpperCase()] || fallbacks[index % fallbacks.length];
  };

  const datasets = uniqueChannels.map((channel, index) => {
    const dataPoints = uniqueDates.map((date) => {
      const record = rawData.find(
        (item) => item.AsOfDate === date && item.channelpartner === channel,
      );
      return record ? parseFloat(record.RoomSold) || 0 : 0;
    });

    const color = getChannelColor(channel, index);

    return {
      label: channel,
      data: dataPoints,
      borderColor: color,
      backgroundColor: color, // Solid color for stacked area
      fill: true,
      borderWidth: 1,
      tension: 0.1,
      pointRadius: 3,
      pointBackgroundColor: color,
      pointBorderColor: color,
      pointHoverRadius: 5,
    };
  });

  const chartData = {
    labels: labels,
    datasets: datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "center",
        labels: {
          color: "#64748b",
          usePointStyle: false,
          boxWidth: 8,
          boxHeight: 8,
          padding: 20,
          font: {
            size: 13,
            family: "system-ui, -apple-system, sans-serif",
          },
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(15, 23, 42, 0.95)",
        titleColor: "#f8fafc",
        bodyColor: "#f8fafc",
        borderColor: "#334155",
        borderWidth: 1,
        callbacks: {
          title: function (context) {
            return context[0].label;
          },
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y;
            }
            return label;
          },
          footer: function (tooltipItems) {
            let total = 0;
            tooltipItems.forEach(function (tooltipItem) {
              total += tooltipItem.parsed.y;
            });
            return "Total: " + total;
          },
        },
        footerFont: {
          weight: "bold",
        },
        padding: 12,
        titleFont: {
          size: 14,
          weight: "bold",
        },
        bodyFont: {
          size: 13,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#64748b",
          font: {
            size: 12,
            family: "system-ui, -apple-system, sans-serif",
          },
        },
      },
      y: {
        stacked: true,
        max: propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms
          ? parseInt(propertyDetailFromRTK?.revenuconfig?.[0]?.totalrooms)
          : undefined,
        title: {
          display: true,
          text: "Rooms sold",
          color: "#64748b",
          font: {
            size: 13,
            family: "system-ui, -apple-system, sans-serif",
          },
        },
        grid: {
          color: "#f1f5f9",
          drawBorder: false,
        },
        border: {
          display: false,
        },
        ticks: {
          color: "#64748b",
          padding: 10,
          font: {
            size: 12,
            family: "system-ui, -apple-system, sans-serif",
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID("ChannelMix","emailIcon", propertyDetailFromRTK?.propertyid)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.ChannelMixTable,
                  "ChannelMix",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "ChannelMix",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.ChannelMix || "ChannelMix",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("ChannelMix","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.ChannelMixTable,
                  `${para?.propertyCode}-ChannelMix-${moment(new Date()).format("MMDDYYYY")}`
                )
              }
            />
          </Button> */}
        </div>
      )}  

      {loading ? (
        <div className="market-share-loading">
          <Loader />
        </div>
      ) : (
        <div className="market-share-chart-container">
          <Line data={chartData} options={options} />
        </div>
      )}
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"ChannelMix" + tblids.ChannelMixTable}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default ChannelMix;
